module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds_en.0b739d30a0a888b6a0d8ef30b682d3f9.png";